
import React from 'react';

const MessageSection: React.FC = () => {
  return (
    <section id="message-section" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">
            代表メッセージ
          </h2>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <p className="text-lg leading-relaxed text-gray-700">
                私たちは「地域とともに成長する」という理念のもと、住まい探し・売却・管理など、
                地域の皆様に寄り添った不動産サービスを提供してまいりました。
              </p>
              <p className="text-lg leading-relaxed text-gray-700">
                住まいは"暮らしの土台"。その一つひとつを丁寧に支えることで、
                お客様の人生の節目に寄り添える企業であり続けたいと考えています。
              </p>
              <p className="text-lg leading-relaxed text-gray-700">
                地域に根ざした信頼関係を大切にし、お客様一人ひとりのライフスタイルに合った
                最適なご提案をお届けいたします。
              </p>
              <div className="pt-4">
                <p className="text-xl font-semibold text-gray-800">
                  株式会社PM不動産
                </p>
                <p className="text-lg text-gray-600">
                  代表取締役　田中 太郎
                </p>
              </div>
            </div>
            <div className="flex justify-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/0660fb42337ae8e8cfe1e76bc732c8c0.jpg"
                alt="代表取締役 田中太郎"
                className="w-80 h-96 object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MessageSection;
